import _ from 'lodash';
import config from '../package.json';

export const getChangeEmailStepContext = (state: {}) => {
  return _.get(
    state,
    `hk-emma-web-core/app.moduleConfig.emma-customer-profile.changeEmailStepContext`,
    {},
  );
};

export const getChangeEmailLabels = (state: {}) => {
  return _.get(
    state,
    `hk-emma-web-core/app.moduleConfig.emma-customer-profile.changeEmailLabels`,
    {},
  );
};

export const getNewEmail = (state: {}) => {
  return _.get(
    state,
    `hk-emma-web-core/customerProfile.changeEmail.newEmail`,
    '',
  );
};

export const getTransactionId = (state: {}) => {
  return _.get(
    state,
    `hk-emma-web-core/customerProfile.changeEmail.transactionId`,
    '',
  );
};

export const getSelectedList = (state: {}) => {
  return _.get(
    state,
    `hk-emma-web-core/customerProfile.changeEmail.selectedList`,
    [],
  );
};

export const getOtherPolicyList = (state: {}) => {
  return _.get(
    state,
    `hk-emma-web-core/customerProfile.changeEmail.otherPolicyList`,
    [],
  );
};

export const getTransactions = (state: {}) => {
  return _.get(
    state,
    `hk-emma-web-core/customerProfile.changeEmail.transactions`,
    [],
  );
};

export const getSuccessfulPolicies = (state: {}) => {
  return _.get(
    state,
    `hk-emma-web-core/customerProfile.changeEmail.SuccessfulPolicies`,
    [],
  );
};

export const getFailedPolicies = (state: {}) => {
  return _.get(
    state,
    `hk-emma-web-core/customerProfile.changeEmail.failedPolicies`,
    [],
  );
};

export const getIsLoading = (state: {}) => {
  return _.get(
    state,
    `hk-emma-web-core/customerProfile.changeEmail.isLoading`,
    false,
  );
};

export const getForm = (state: {}) => {
  return _.get(state, `hk-emma-web-core/customerProfile.changeEmail.form`, {});
};

export const getGoGreenList = (state: {}) => {
  return _.get(
    state,
    `hk-emma-web-core/customerProfile.changeEmail.goGreenList`,
    [],
  );
};
